import React from "react";

const PageLoading = () => {
  return (
    <div className="z-50 min-w-full min-h-screen flex items-center justify-center bg-blue-100">
      <p className="text-center text-3xl font-bold animate-bounce">Loading...</p>
    </div>
  );
};

export default PageLoading;
